export const ADMIN_CUSTOMER_VIEW_PATH_PREFIX = "/admin/customer-view";

export type AppBootProfile = "ordinary" | "customer-view";

export type CapturedAppBootProfile =
  | { status: "valid"; profile: AppBootProfile }
  | { status: "invalid" };

declare global {
  interface Window {
    __RP_APP_BOOT_PROFILE_SENTINEL__?: unknown;
  }
}

let captured: CapturedAppBootProfile | null = null;

export function isAdminCustomerViewRoutePath(pathname: string): boolean {
  return pathname === ADMIN_CUSTOMER_VIEW_PATH_PREFIX
    || pathname.startsWith(`${ADMIN_CUSTOMER_VIEW_PATH_PREFIX}/`);
}

export function classifyAppBootRouteFamily(
  pathname: string
): AppBootProfile {
  return isAdminCustomerViewRoutePath(pathname) ? "customer-view" : "ordinary";
}

function readSentinel(): CapturedAppBootProfile {
  if (typeof window === "undefined") {
    return { status: "invalid" };
  }
  const sentinel = window.__RP_APP_BOOT_PROFILE_SENTINEL__;
  if (sentinel === "ordinary" || sentinel === "customer-view") {
    return { status: "valid", profile: sentinel };
  }
  return { status: "invalid" };
}

export function captureAppBootProfile(): CapturedAppBootProfile {
  if (captured !== null) {
    return captured;
  }
  captured = readSentinel();
  return captured;
}

export function getCapturedAppBootProfile(): CapturedAppBootProfile {
  return captured ?? { status: "invalid" };
}

export function isCustomerViewBootProfile(): boolean {
  const boot = getCapturedAppBootProfile();
  return boot.status === "valid" && boot.profile === "customer-view";
}

export function resetCapturedAppBootProfileForTests(): void {
  captured = null;
}
